import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import { ordersActions } from "_store/actions";

export function ErrorModal() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleConfirm = () => {
    dispatch(ordersActions.clearOrdersError());
    navigate("/");
  };

  return (
    <Modal centered show size="md" onHide={handleConfirm}>
      <Modal.Header style={{ border: 0 }}>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Something went wrong... <br /> You will be redirected on main page.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleConfirm}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
